import React from 'react';

import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles: any = makeStyles((theme: any) => ({
  root: {
    margin: theme.spacing(2, 3),
    border: 1,
  },
  value: {
    fontWeight: 500,
    width: '100%',
  },
}));

interface Props {
  children?: React.ReactNode;
  dataTestId: string;
}

const FieldValue = (props: Props) => {
  const classes = useStyles();
  const { children, dataTestId } = props;

  return (
    <Typography variant='body1' className={classes.value} data-testid={dataTestId}>
      {children}
    </Typography>
  );
};

export default FieldValue;
